const ProductManagerDisplay = () => import('./src/App.vue')

const install = (Vue, options = {}) => {
  if (options.hasOwnProperty('agGridComponent') && options.agGridComponent) {
    Vue.component('vuejs-product-manager-ag-grid', options.agGridComponent)
  } else {
    // In SSR mode or when agGridComponent is not available, register a placeholder component
    Vue.component('vuejs-product-manager-ag-grid', {
      template: '<div class="ag-grid-ssr-placeholder">AG Grid not available in SSR mode</div>',
      name: 'vuejs-product-manager-ag-grid-placeholder'
    })
  }
}

export default { install, ProductManagerDisplay }
